<template>
  <div style="height: 100%;width: 100%">
    <div style="height: 6%;position:relative;width: 100%;margin-bottom: 1%;display: flex;align-items: center">
      <div style="display: flex;width: 50%">
        <div style="margin-left: 10px;top: 10px">
          项目状态：
          <el-select v-model="searchMore.state" placeholder="请选择" @change="getData">
            <el-option label="全部" value=""></el-option>
            <el-option label="进行中" value="进行中"></el-option>
            <el-option label="驳回" value="驳回"></el-option>
            <el-option label="通过" value="通过"></el-option>
            <el-option label="退回" value="退回"></el-option>
          </el-select>
        </div>
        <div style="margin-left: 10px">
          项目年份：
          <el-date-picker
            @change="getData"
            v-model="searchMore.selectyear"
            type="year"
            value-format='yyyy'
            placeholder="选择年">
          </el-date-picker>
        </div>
      </div>
      <div style="display: flex;width: 50%;justify-content: flex-end">
        <el-button size="medium" style="margin-right: 10px" @click="onExportAuditResultSum">初审导出</el-button>
        <el-button size="medium" type="danger" style="margin-right: 10px" @click="onTimeSetting">系统设置</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      stripe
      style="width: 100%">
      <el-table-column
        prop="name"
        label="项目名称"
        width="280"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="grade"
        label="推荐等级"
        width="180"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="unit"
        label="推荐单位"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="awardtype"
        label="奖励类别"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="people"
        label="参与人"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <!--      <el-table-column
              prop="schedule"
              label="进度"
              align="center"
              show-overflow-tooltip>
            </el-table-column>-->
      <el-table-column
        prop="state"
        label="项目状态"
        align="center"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <div @click="onShowFlow(scope.row)" style="cursor: pointer">
            <div v-if="scope.row.state=='进行中'" style="color:#409EFF ">{{ scope.row.state }}</div>
            <div v-if="scope.row.state=='通过'" style="color:#67C23A ">{{ scope.row.state }}</div>
            <div v-if="scope.row.state=='驳回'" style="color:#F56C6C ">{{ scope.row.state }}</div>
            <div v-if="scope.row.state=='退回'" style="color:#E6A23C ">{{ scope.row.state }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="state"
        label="初审状态"
        align="center"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.checkopinion=='0'">未初审</span>
          <span v-if="scope.row.checkopinion=='1'" style="color:#E6A23C ">已初审</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="操作"
        align="center"
        width="400">
        <template slot-scope="scope">
          <el-button size="mini" @click="onExport(scope.row)">导出</el-button>
          <el-button type="primary" size="mini" @click="onRead(scope.row)">查看</el-button>
          <el-button type="warning" size="mini" @click="onAuditResult(scope.row)">初审</el-button>
          <el-button v-if="scope.row.state=='进行中'" type="danger" size="mini" @click="onAudit(scope.row)">审核</el-button>
          <!--          <el-button v-if="scope.row.state=='进行中'" type="success" size="mini" @click="onAudit(scope.row,1)">通过</el-button>
                    <el-button v-if="scope.row.state=='进行中'" type="warning" size="mini" @click="onAudit(scope.row,3)">退回</el-button>
                    <el-tooltip class="item" effect="dark" content="驳回后用户不可再次修改提交" placement="top">
                      <el-button v-if="scope.row.state=='进行中'" type="danger" size="mini" @click="onAudit(scope.row,2)">驳回</el-button>
                    </el-tooltip>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <el-dialog
      :title="auditTitle"
      :visible.sync="dialogVisibleAudit"
      width="30%"
      :before-close="handleCloseAudit"
      :close-on-click-modal="false"
      center>
      <el-form ref="formAudit" :model="auditData" :rules="rulesAudit">
        <el-form-item prop="opinion" label="审核结果">
          <el-radio v-model="auditData.check" label="1">通过</el-radio>
          <el-radio v-model="auditData.check" label="3">退回</el-radio>
          <el-radio v-model="auditData.check" label="2">驳回</el-radio>
        </el-form-item>
        <el-form-item prop="opinion" label="审核意见">
          <el-input style="width: 80%;display: inline-block" type="textarea" :autosize="{ minRows: 3}" v-model="auditData.opinion" :placeholder="placeholder"></el-input>
        </el-form-item>
        <div style="font-size: 10px;margin-left: 15%">注：退回后用户可修改后再次提交项目，驳回后用户项目不可再次修改提交。</div>
        <!--        <el-upload
                  style="margin-left: 3%;width: 50%"
                  :auto-upload="false"
                  action="#"
                  multiple
                  :on-change="handleChange"
                  :file-list="files">
                  <div>附件上传：<i class="el-icon-folder-add" style="color:#409EFF "></i></div>
                </el-upload>-->

      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleCloseAudit">取 消</el-button>
    <el-button type="primary" @click="onAuditSave">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
      title="系统设置"
      :visible.sync="dialogVisibleTimeSetting"
      width="25%"
      :before-close="handleCloseTimeSetting"
      :close-on-click-modal="false">
      <el-form ref="formTimeSetting" :model="timeSettingData" :rules="rulesTimeSetting" style="padding-left: 9%">
        <el-form-item prop="starttime" label="评奖开始时间：">
          <el-date-picker
            v-model="timeSettingData.starttime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="设置评奖开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="endtime" label="评奖结束时间：">
          <el-date-picker
            v-model="timeSettingData.endtime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="设置评奖结束时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleCloseTimeSetting">取 消</el-button>
    <el-button type="primary" @click="onTimeSettingSave">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
      title="进度详情"
      :visible.sync="dialogVisibleFlow"
      width="30%"
      :before-close="handleCloseFlow">
      <div>
        <el-timeline>
          <el-timeline-item v-for="(obj,index) in this.flowData" :key="obj.addtime" :timestamp="obj.submitdate||obj.checktime" placement="top">
            <el-card>
              <h4 v-if='obj.type=="提交申请"'>{{ obj.type }}</h4>
              <h4>{{ obj.state }}</h4>
              <p v-if="obj.opinion">审核意见：{{ obj.opinion }}</p>
              <p>操作人：{{ obj.operator }}{{ obj.approver }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
    <el-dialog
      title="初审导出"
      :visible.sync="dialogVisibleAuditSum"
      :before-close="handleCloseAuditSum"
      width="30%"
      center>
      <span>导出年份：</span>
      <el-date-picker
        style="width:80%;display: inline-block"
        v-model="exportYear"
        type="year"
        placeholder="选择导出年份">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleCloseAuditSum">取 消</el-button>
    <el-button type="primary" @click="onExportAuditResultSumSave">确 定</el-button>
  </span>
    </el-dialog>
    <fundAuidtPublicDialog
      v-if="dialogVisibleAuditResult"
      :dialogVisible.sync="dialogVisibleAuditResult"
      :isRefresh.sync="isRefresh"
      :pbcid="pbcidAuditResult">
    </fundAuidtPublicDialog>
  </div>
</template>

<script>

import utils from "../js/utils";
import fundAuidtPublicDialog from "./ProjectSequence/fundAuidt_publicDialog";

export default {
  name: "AduitAward_Manager",
  data() {
    return {
      searchMore: {
        name: '',
        grade: '',
        awardtype: '',
        state: '',
        selectyear: new Date().getFullYear().toString()
      },
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      currentRow: {},
      check: '',
      dialogVisibleAudit: false,
      auditData: {
        opinion: '',
        check: '1',
      },
      auditTitle: '',
      placeholder: '',
      rulesAudit: {
        opinion: {required: true, message: ' ', trigger: 'blur'}
      },
      dialogVisibleTimeSetting: false,
      timeSettingData: {
        starttime: '',
        endtime: '',
        type: '评奖时间'
      },
      rulesTimeSetting: {
        starttime: {required: true, message: ' ', trigger: 'blur'},
        endtime: {required: true, message: ' ', trigger: 'blur'},
      },
      files: [],
      dialogVisibleFlow: false,
      flowData: [],
      //  查看初审结果
      dialogVisibleAuditResult: false,
      pbcidAuditResult: '',
      exportYear: '',
      dialogVisibleAuditSum: false,
      isRefresh: false
    }
  },
  components: {
    fundAuidtPublicDialog
  },
  methods: {
    initQueryData() {
      if (this.$route.query.pageSize !== undefined && this.$route.query.pageNum !== undefined) {
        this.pageSize = Number(this.$route.query.pageSize)
        this.pageNum = Number(this.$route.query.pageNum)
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getData()
    },
    getData() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectlist',
        params: {
          name: this.searchMore.name,
          awardtype: this.searchMore.awardtype,
          state: this.searchMore.state,
          selectyear: this.searchMore.selectyear,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.tableData = resp.data.list
          this.total = resp.data.total
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    onExport(row) {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/file/downprojectpdf',
        params: {
          pbcid: row.pbcid
        },
        responseType: 'blob'
      }).then(res => {
        const filename = row.name + '.docx';
        const blob = new Blob([res.data]);//处理文档流
        const alink = document.createElement('a');
        alink.style.display = 'none';
        alink.href = window.URL.createObjectURL(blob);
        alink.setAttribute('download', decodeURI(filename))
        document.body.appendChild(alink);
        alink.click();
        window.URL.revokeObjectURL(alink.href); // 释放URL 对象
        document.body.removeChild(alink);
      })
    },
    onRead(row) {
      sessionStorage.setItem("pbcid", row.pbcid)
      sessionStorage.setItem("openWith", 'readOnly')
      this.$router.push({
        path: '/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01',
        query: {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        }
      })
    },
    /*
        onAudit(row, check) {
          switch (check) {
            case 1:
              this.auditTitle = '通过'
              this.placeholder = '请填写通过意见';
              break
            case 2:
              this.auditTitle = '驳回'
              this.placeholder = '请填写驳回意见';
              break
            case 3:
              this.auditTitle = '退回'
              this.placeholder = '请填写退回意见';
              break
          }
          this.currentRow = row
          this.check = check
          this.dialogVisibleAudit = true

        },
    */
    onAudit(row) {
      this.currentRow = row
      this.auditTitle = '审核'
      this.dialogVisibleAudit = true
    },
    onAuditSave() {
      this.$refs['formAudit'].validate((valid) => {
        if (valid) {
          this.$axios({
            method: 'post',
            url: this.GLOBAL.URL + 'pingjiang/admin/checkproject',
            data: {
              pbcid: this.currentRow.pbcid,
              type: this.currentRow.type,
              approver: sessionStorage.getItem('username'),
              opinion: this.auditData.opinion,
              check: this.auditData.check,
            }
          }).then(res => {
            let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
            if (resp.code == 1000) {
              this.showSuccessMsg(resp.message)
              this.handleCloseAudit()
              this.getData()
              // this.handleUpload()
            } else {
              this.showFailMsg(resp.message)
            }
          })
        } else {
          return false;
        }
      });
    },
    handleCloseAudit() {
      this.dialogVisibleAudit = false
      Object.assign(this.auditData, this.$options.data().auditData)
    },
    onTimeSetting() {
      this.dialogVisibleTimeSetting = true
      this.getTimeSetting()
    },
    getTimeSetting() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/admin/selectsystemtime',
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          if (resp.data.length == 0) {
            return
          }
          this.timeSettingData = resp.data[0]
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    onTimeSettingSave() {
      if (this.timeSettingData.sid !== undefined) {
        //  调用修改接口
        this.$axios({
          method: 'post',
          url: this.GLOBAL.URL + 'pingjiang/admin/updatesystemtime',
          data: {
            sid: this.timeSettingData.sid,
            name: '2022年评审时间',
            starttime: this.timeSettingData.starttime,
            endtime: this.timeSettingData.endtime,
            type: this.timeSettingData.type,
          }
        }).then(res => {
          let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
          if (resp.code == 1000) {
            this.showSuccessMsg(resp.message)
            this.handleCloseTimeSetting()
          } else {
            this.showFailMsg(resp.message)
          }
        })

      } else {
        //调用保存接口
        this.$axios({
          method: 'post',
          url: this.GLOBAL.URL + 'pingjiang/admin/setappertime',
          data: {
            name: '2022年评审时间',
            starttime: this.timeSettingData.starttime,
            endtime: this.timeSettingData.endtime,
            type: this.timeSettingData.type,
          }
        }).then(res => {
          let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
          if (resp.code == 1000) {
            this.showSuccessMsg(resp.message)
            this.handleCloseTimeSetting()
          } else {
            this.showFailMsg(resp.message)
          }
        })
      }
    },
    handleCloseTimeSetting() {
      this.dialogVisibleTimeSetting = false
      this.$refs['formTimeSetting'].resetFields()
    },
    handleChange(file, fileList) {
      this.files = fileList
    },
    handleUpload() {
      let formData = new FormData()
      this.files.filter(obj => obj.status == "ready").forEach((obj, index) => {
        formData.append('files', obj.raw)
      })
      formData.append('pbcid', sessionStorage.getItem('pbcid'))
      formData.append('type', '附件')
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/file/addfile',
        data: formData
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
          this.handleCloseAudit()
          this.getData()
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    onShowFlow(row) {
      this.dialogVisibleFlow = true
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectflow',
        params: {
          pbcid: row.pbcid
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.flowData = resp.data
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    handleCloseFlow() {
      this.dialogVisibleFlow = false
    },
    onAuditResult(row) {
      this.pbcidAuditResult = row.pbcid
      this.dialogVisibleAuditResult = true

    },
    onExportAuditResultSum() {
      this.dialogVisibleAuditSum = true
    },
    handleCloseAuditSum() {
      this.exportYear = ''
      this.dialogVisibleAuditSum = false

    },
    onExportAuditResultSumSave() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/admin/exportcheckexcel',
        params: {
          year: 2022
        },
        responseType: 'blob'
      }).then(res => {
        const filename = '初审结果汇总表' + '.xlsx';
        const blob = new Blob([res.data]);//处理文档流
        const alink = document.createElement('a');
        alink.style.display = 'none';
        alink.href = window.URL.createObjectURL(blob);
        alink.setAttribute('download', decodeURI(filename))
        document.body.appendChild(alink);
        alink.click();
        window.URL.revokeObjectURL(alink.href); // 释放URL 对象
        document.body.removeChild(alink);
      })
    },
  },
  watch: {
    isRefresh(val, oldval) {
      if (val) {
        this.getData()
        this.isRefresh = false
      }
    }
  },
  created() {
    sessionStorage.removeItem('pbcid');
    this.initQueryData()
    this.getData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/PJGL/AduitAward_Manager.vue